export const gtag = () =>
    window && window?.gtag ? window?.gtag : () => {};

export const sendGtagEvent = (type, params) => {
    gtag()("event", type, params);
};